import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { PaginatorModule } from 'primeng/paginator';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { AdministratorService } from '../../../../services/administrator.service';
import { Warehouse, warehouseGridResponse } from '../../../../model/administration.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { InventoryService } from '../../../../services/inventory.service';

@Component({
  selector: 'app-list-warehouse',
  standalone: true,
  imports: [SharedModule, CommonModule, PaginatorModule],
  templateUrl: './list-warehouse.component.html',
  styleUrl: './list-warehouse.component.scss'
})
export class ListWarehouseComponent {
  selectedwarehouse: Warehouse[] = [];
  @Input() companyId: any;
  constructor(private warehouseService: AdministratorService, private route: Router, private confirmationService: ConfirmationService, private messageService: MessageService, public inventoryService: InventoryService) { }
  @ViewChild('dt1') dt1: Table | undefined;

  Warehouses: Warehouse[] = [];
  start: number = 0;
  loader: boolean = false;
  rowsPerPage: number = 5;
  searchKey: any;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }


  result: warehouseGridResponse = {
    warehouses: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  unitLabel: string = '';

  ngOnInit(): void {
    // this.pageRequest.pageIndex = 0;
    // this.pageRequest.pageSize = this.rowsPerPage
    this.getWarehouse(this.pageRequest);
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
      this.setPageTitle();

      this.messages = [
        `${this.unitLabel} Code`, `${this.unitLabel} Name`, `Person Name`, `City`
      ];
      this.searchEffect();
    });
  }

  setPageTitle() {
    document.title = `${this.unitLabel} List`;
  }


  getWarehouse(query: gridPageRequest) {
    this.warehouseService.getAllWarehouse(query).subscribe({
      next: data => {
        this.result = data as warehouseGridResponse;
        //console.log(this.result);
        this.pageCalculation();
      },
      error: error => {

      }
    });
  }

  contact(id: number) {

  }

  pageCalculation() {
    // this.pageRequest.pageSize = this.rowsPerPage;
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
    // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
  }

  createWarehouse() {
    this.route.navigate(['/home/createWarehouse']);
  }

  editWarehouse(data?: any) {
    if (data) {
      this.route.navigate(['/home/createWarehouse'], { queryParams: { 'warehouseId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createWarehouse'], { queryParams: { 'warehouseId': this.selectedwarehouse[0].warehouseId }, skipLocationChange: true },);
    }
  }

  deleteWarehouse() {
    if (this.selectedwarehouse && this.selectedwarehouse.length > 0) {
      this.confirmationService.confirm({
        header: 'Are you sure?',
        message: 'Please confirm to proceed.',
        accept: () => {
          var warehouseIds = _.map(this.selectedwarehouse, 'warehouseId');
          this.loader = true;
          this.warehouseService.deleteWarehouse(warehouseIds).subscribe({
            next: () => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Unit deleted successfully.' });
              this.selectedwarehouse = [];
              this.getWarehouse(this.pageRequest);
              this.loader = false;
            },
            error: error => {
              this.loader = false;
              console.error(error);
            }
          });
        },
        reject: () => {
          // User rejected, do nothing
        }
      });
    }
  }

  // onPrevious() {
  //   this.pageRequest.pageIndex = this.pageRequest.pageIndex - 1;
  //   this.getWarehouse(this.pageRequest);
  // }

  // onNext() {
  //   this.pageRequest.pageIndex = this.pageRequest.pageIndex + 1;
  //   this.getWarehouse(this.pageRequest);
  // }

  loadwarehouses(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchWarehouse();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getWarehouse(this.pageRequest);
    }
  }
  searchWarehouse() {
    if (!this.searchKey) {
      return;
    }

    this.warehouseService.searchWarehouse(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.result.warehouses = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getWarehouse(this.pageRequest);
  }



  placeholder: string = 'Search By ';
  messages: string[] = [];
  private messageIndex = 0;
  private charIndex = 0;

  searchEffect() {
    const base = 'Search By ';

    const typeNextChar = () => {
      if (this.messages.length === 0) return;

      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };

    typeNextChar();
  }
}

